





















import { Component, Vue, Ref, Prop } from "vue-property-decorator";

@Component
export default class CountDownTimer extends Vue {
  @Prop({ default: 30 })
  readonly time!: number;
  @Prop({ default: false })
  readonly forward!: boolean;
  @Prop({ default: "" })
  readonly initialClass!: string;
  @Prop({ default: "" })
  readonly stoppedClass!: string;
  @Prop({ default: "" })
  readonly expiredClass!: string;
  @Prop({ default: "" })
  readonly runningClass!: string;
  @Prop({ default: "" })
  readonly warningClass!: string;
  @Prop({ default: true})
  readonly padNumbers!: boolean;
  @Prop({ default: "${h}:${m}:${s}"})
  readonly format!: string;
  
  mounted() {
    if (!this.forward) {
      this.calcTime(this.time * 1000);
    }
  }

  timer = 0;
  start = 0;
  end = 0;
  interval : any = null;
  days = 0;
  minutes = 0;
  hours = 0;
  seconds = 0;
  message = "";
  status = "";
  statusType = "";
  statusText = "";

  get timeString() {
    const h = this.padNumbers?this.padNumber(this.hours, 2):this.hours;
    const m = this.padNumbers?this.padNumber(this.minutes, 2):this.minutes;
    const s = this.padNumbers?this.padNumber(this.seconds, 2):this.seconds;
    return this.interpolate(this.format, { h: h, m: m, s: s});
  }
  get classObject() {
    return [
      this.statusType == "" ? this.initialClass : "",
      this.statusType == "expired" ? this.expiredClass: "",
      this.statusType == "stopped" ? this.stoppedClass: "",
      this.statusType == "running" ? this.runningClass: "",
      this.statusType == "upcoming" ? this.warningClass: ""
    ];
  }

  init() {
      console.log("INIT");
  }
  interpolate(format: string, params: any) {
    const names = Object.keys(params);
    const vals = Object.values(params);
    return new Function(...names, `return \`${format}\`;`)(...vals);
  }
  startCounter() {
    this.stopCounter();
    this.start = new Date().getTime();
    this.end = this.start + this.time * 1000;

    // Update the count down every 1 second
    this.timerCount(this.start, this.end);
    this.interval = setInterval(() => {
      this.timerCount(this.start, this.end);
    }, 950);
    this.$emit("start_callback", this.status);
  }
  stopCounter() {
    this.calcTime(0);
    clearInterval(this.interval);
    this.statusType = "stopped";
  }
  timerCount(start: number, end: number) {
    // Get todays date and time
    const now = new Date().getTime();

    // Find the distance between now an the count down date
    const time = now - start;
    const timeLeft = end - now;

    if (timeLeft < 0) {
      //start < now && end < now
      //this.message = this.wordString.expired;
      //this.statusText = this.wordString.status.expired;
      this.statusType = "expired";
      clearInterval(this.interval);
      this.$emit("end_callback", this.status);
      return;
    }
    if (this.forward) {
      this.calcTime(time);
    } else {
      this.calcTime(timeLeft);
    }
    this.statusType = "running";
    this.$emit("time_update", {
      forward: this.forward,
      time: time,
      timeLeft: timeLeft
    });
  }
  calcTime(dist: number) {
    // Time calculations for days, hours, minutes and seconds
    this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
    this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
  }
  padNumber(num: number, size: number) {
    const s = "000000000" + num;
    return s.substr(s.length - size);
  }
}
